import styled from 'styled-components';
import { Grid } from '@mui/material';

// CONSTANTS
import colors, { WHITE } from '@/constants/colors';

import { breakpoints } from '@/utility/breakpoints';

export const AuthWrapper = styled(Grid)`
  min-height: 100vh;
  position: relative;
  background-color: ${WHITE};
`;

export const Wrapper = styled(Grid)`
  position: relative;
  width: 100%;
  max-width: calc(100% - 240px);
  height: 100%;

  ${breakpoints.down('lg')} {
    max-width: initial;
  }
`;

export const ProgressWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: relative;
  z-index: 1102;
  background: ${colors.background};
`;

export const ContentWrap = styled.div``;
